import { insertTagschema, patchTagschema } from "@/api/db/schema/tag";
import { queryOptions } from "@tanstack/react-query";
import { createServerFn } from "@tanstack/react-start";
import z from "zod";
import { deleteTag } from "../../api/services/tags/delete";
import { getAllTags, getSelectedTag } from "../../api/services/tags/get";
import { updateTag } from "../../api/services/tags/patch";
import { createTag } from "../../api/services/tags/post";
import { authMiddlewareServer } from "../middleware/auth";

export const getAllTagsFn = createServerFn({ method: "GET" })
  .middleware([])
  .handler(async () => {
    const tags = await getAllTags();
    return {
      status: 200,
      body: { tags },
    };
  });

export const getSelectTagFn = createServerFn({ method: "GET" })
  .inputValidator(
    z.object({
      tagId: z.string().min(1, "Tag ID is required"),
    }),
  )
  .middleware([])
  .handler(async ({ data }) => {
    const tag = await getSelectedTag(data.tagId);
    return {
      status: 200,
      body: { tag },
    };
  });

export const getSelectedTagOptions = ({ tagId }: { tagId: string }) =>
  queryOptions({
    queryKey: ["getSelectedTag", tagId],
    queryFn: () => getSelectTagFn({ data: { tagId } }),
  });

export const createTagFn = createServerFn({ method: "POST" })
  .middleware([authMiddlewareServer])
  .inputValidator(insertTagschema)
  .handler(async ({ context, data }) => {
    const user = context.auth;
    const tag = await createTag(data, user.userId);
    return {
      status: 201,
      body: { tag },
    };
  });

export const patchTagFn = createServerFn({ method: "POST" })
  .inputValidator(patchTagschema)
  .middleware([authMiddlewareServer])
  .handler(async ({ context, data }) => {
    const user = context.auth;

    const tag = await updateTag(data, user.userId);
    return {
      status: 200,
      body: { tag },
    };
  });

export const deleteTagn = createServerFn({ method: "POST" })
  .inputValidator(
    z.object({
      tagId: z.string().min(1, "Tag ID is required"),
    }),
  )
  .middleware([authMiddlewareServer])
  .handler(async ({ context, data }) => {
    const user = context.auth;

    const tag = await deleteTag(data.tagId, user.userId);
    return {
      status: 200,
      body: { tag },
    };
  });
